import { Sparkles } from 'lucide-react';
import { buildSelectedPocsColumns } from './useSelectedPOCsColumns';

export const selectedPocsOptimizedColumns = (pocBudgets = {}, onBudgetChange, onRemovePOC) =>
  buildSelectedPocsColumns(pocBudgets, onBudgetChange, onRemovePOC, {
    budgetHeader: 'Budget (Optimized)',
    budgetInputClassName:
      'block w-full rounded-lg border-2 border-blue-100 pl-7 py-1.5 text-sm focus:border-blue-500 transition-all hover:border-blue-200 focus:outline-none bg-blue-50/30',
    showOptimizedIcon: true,
    OptimizedIcon: Sparkles,
    includeOverlapping: true,
  });
